module.exports = __webpack_public_path__ + "img/big_1_13.ecf15437.png";